export const CONTRACT = {
  CONTRACTS: 'contracts',
};
